export default __webpack_public_path__ + "static/media/right_arrow_green.01781ad6.svg";